module.exports = __webpack_public_path__ + "assets/segment.93dd48ad.svg";